import React from 'react';
import {Route, useRouteMatch, Switch} from "react-router-dom";

// Notifications Pages
import NotificationList from "./List";
import SentNotifications from "./Sent";
import NotificationDetails from "./Details";
import NewNotification from "./New";

const Notifications = () => {
   let match = useRouteMatch();

   return <Switch>
      <Route exact path={"/notifications"} component={NotificationList}/>

      <Route
          exact
          path={`${match.path}/sent`}
          render={(props) => <SentNotifications {...props} />}
      />

      <Route
         exact
         path={`${match.path}/new`}
         render={(props) => <NewNotification {...props} />}
      />

      <Route
         exact
         path={`${match.path}/:id`}
         render={(props) => <NotificationDetails {...props} />}
      />
   </Switch>
}

export default Notifications;